module.exports = __webpack_public_path__ + "img/logo.8b91b0a9.png";